import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import { Accordion, AccordionDetails, Box, Grid, Link } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AutocompleteCustomized from "../../../common/components/AutocompletCustomized";
import ButtonCustomized from "../../../common/components/ButtonCustomized";
import DatePickerCustomized from "../../../common/components/DatePickerCustomized";
import PaperCustomized from "../../../common/components/PaperCustomized";
import SelectCustomized from "../../../common/components/SelectCustomized";
import TableCustomized from "../../../common/components/TableCustomized";
import TextFieldCustomized from "../../../common/components/TextFieldCustomized";
import {
  formattedDateFromDB,
  recursiveFormatDateTI,
} from "../../../common/utils/FunctionsUtils";
import { iceRegex } from "../../../common/utils/regexUtils";
import {
  getTiDeclarants,
  getTiGuichets,
  getTiImportateurs,
  getTiNomenclatures,
  getTiTypeTE,
  getTiTypeTI,
} from "../state/TiActions";

function SearchTitreForm(props) {
  const dispatch = useDispatch();
  const tiReducer = useSelector((state) => state.tiReducer);
  const titreReducer = useSelector((state) => state.titreReducer);
  const [expanded, setExpanded] = useState(
    tiReducer?.expandedSearchForm || false
  );
  const isLoading = tiReducer?.isLoading;
  const [resetKey, setResetKey] = useState(0);

  const findEtatById = (etatId) => {
    const etat = tiReducer?.etats?.find((etat) => etat.id === etatId);
    if (etat) {
      return {
        label: "(" + etat.code + ") " + etat.description,
        value: etat?.id,
      };
    } else {
      return [];
    }
  };

  const findEtatByCode = (etatCode) => {
    const etat = tiReducer?.etats?.find((etat) => etat.code === etatCode);
    if (etat) {
      return {
        description: etat?.description,
        code: etat?.code,
        value: etat?.id,
      };
    } else {
      return [];
    }
  };

  const findCategorieById = (catId) => {
    const categorie = tiReducer?.categories?.find((etat) => etat.id === catId);
    if (categorie) {
      return {
        label: "(" + categorie.code + ") " + categorie.description,
        value: categorie?.id,
      };
    } else {
      return [];
    }
  };

  const findStatusModifById = (statusId) => {
    const status = tiReducer?.statusModif?.find(
      (status) => status.id === statusId
    );
    if (status) {
      return {
        label: "(" + status.code + ") " + status.description,
        value: status?.id,
      };
    } else {
      return [];
    }
  };

  const findTypeMessageById = (typeMsgId) => {
    const typeM = tiReducer?.typeMessages?.find(
      (typeM) => typeM.id === typeMsgId
    );
    if (typeM) {
      return {
        label: "(" + typeM.code + ") " + typeM.description,
        value: typeM?.id,
      };
    } else {
      return [];
    }
  };

  const findBanqueById = (banqueId) => {
    const bq = tiReducer?.banques?.find((b) => b.id === banqueId);
    if (bq) {
      return {
        label: "(" + bq.code + ") " + bq.description,
        value: bq?.id,
      };
    }
  };

  const findReglementById = (reglementId) => {
    const bq = tiReducer?.reglements?.find((b) => b.id === reglementId);
    if (bq) {
      return {
        label: "(" + bq.code + ") " + bq.description,
        value: bq?.id,
      };
    }
  };

  const findApurementById = (apurementId) => {
    const bq = tiReducer?.apurements?.find((b) => b.id === apurementId);
    if (bq) {
      return {
        label: "(" + bq.code + ") " + bq.description,
        value: bq?.id,
      };
    }
  };

  //Champs de recherche
  const [isModeConsultation, setModeConsultation] = useState(
    titreReducer?.consultingMode
  );

  const [numEnr, setNumEnr] = useState(
    tiReducer?.searchTitreObject?.tiDto?.numEnr
  );

  const [numDom, setNumDom] = useState(
    tiReducer?.searchTitreObject?.tiDto?.numDom
  );

  const [refFact, setRefFact] = useState(
    tiReducer?.searchTitreObject?.tiDto?.refFact
  );

  const [dateCreationDu, setDateCreationDu] = useState(
    recursiveFormatDateTI(tiReducer?.searchTitreObject?.tiDto?.fromDateCreation)
  );

  const [dateCreationAu, setDateCreationAu] = useState(
    recursiveFormatDateTI(tiReducer?.searchTitreObject?.tiDto?.toDateCreation)
  );

  const [dateDomiciliationDu, setDateDomiciliationDu] = useState(
    recursiveFormatDateTI(
      tiReducer?.searchTitreObject?.tiDto?.fromDateDomiciliation
    )
  );

  const [dateDomiciliationAu, setDateDomiciliationAu] = useState(
    recursiveFormatDateTI(
      tiReducer?.searchTitreObject?.tiDto?.toDateDomiciliation
    )
  );

  const [selectedEtat, setSelectedEtat] = useState(
    findEtatById(tiReducer?.searchTitreObject?.tiDto?.idEtat || null)
  );

  const [selectedCategorie, setSelectedCategorie] = useState(
    findCategorieById(tiReducer?.searchTitreObject?.tiDto?.idCategorie || null)
  );

  const [selectedStatusModif, setSelectedStatusModif] = useState(
    findStatusModifById(
      tiReducer?.searchTitreObject?.tiDto?.idStatusModif || null
    )
  );

  const [selectedTypeMessage, setSelectedTypeMessage] = useState(
    findTypeMessageById(
      tiReducer?.searchTitreObject?.tiDto?.idTypeMessage || null
    )
  );

  const [selectedBanque, setSelectedBanque] = useState(
    findBanqueById(tiReducer?.searchTitreObject?.tiDto?.idBanque || null)
  );

  const [selectedReglement, setSelectedReglement] = useState(
    findReglementById(tiReducer?.searchTitreObject?.tiDto?.idReglement || null)
  );

  const [selectedApurement, setSelectedApurement] = useState(
    findApurementById(tiReducer?.searchTitreObject?.tiDto?.idApurement || null)
  );

  const [idNomenclature, setIdNomenclature] = useState(
    tiReducer?.searchTitreObject?.tiDto?.idNomenclature
  );

  const [idGuichet, setIdGuichet] = useState(
    tiReducer?.searchTitreObject?.tiDto?.idGuichet
  );

  const [idDeclarant, setIdDeclarant] = useState(
    tiReducer?.searchTitreObject?.tiDto?.idDeclarant
  );

  const [idImportateur, setIdImportateur] = useState(
    tiReducer?.searchTitreObject?.tiDto?.idImportateur || ""
  );

  const [nomenclatureNom, setNomenclatureNom] = useState(
    tiReducer?.searchTitreObject?.tiDto?.nomenclatureNom
  );

  const [guichetNom, setGuichetNom] = useState(
    tiReducer?.searchTitreObject?.tiDto?.guichetNom
  );

  const [declarantNom, setDeclarantNom] = useState(
    tiReducer?.searchTitreObject?.tiDto?.declarantNom
  );

  const [importateurNom, setImportateurNom] = useState(
    tiReducer?.searchTitreObject?.tiDto?.importateurNom
  );

  //Recherche générale et pagination
  const pagination = useSelector(
    (state) => state.tiReducer?.searchTitreObject?.pagination
  );

  const [searchObject, setSearchObject] = useState({
    modeConsultation: isModeConsultation,
    tiDto: { ...props.searchObject?.tiDto },
    pagination: props.searchObject?.pagination,
  });

  //Data autocompletes
  const etats =
    tiReducer?.etats
      ?.filter((et) => !(isModeConsultation && et.code === "AT"))
      ?.map((et) => ({
        label: "(" + et.code + ") " + et.description,
        value: et.id,
      })) || [];

  const categories =
    tiReducer?.categories?.map((cat) => ({
      label: "(" + cat.code + ") " + cat.description,
      value: cat.id,
    })) || [];

  const statusModif =
    tiReducer?.statusModif?.map((st) => ({
      label: st.description,
      value: st.id,
    })) || [];

  const typeMessages =
    tiReducer?.typeMessages?.map((type) => ({
      label: "(" + type.code + ") " + type.description,
      value: type.id,
    })) || [];

  const banquesGuichet =
    tiReducer?.banques?.map((type) => ({
      label: type.description + " (" + type.code + ")",
      value: type.code,
    })) || [];

  const reglements =
    tiReducer?.reglements?.map((type) => ({
      label: " (" + type.code + ") " + type.description,
      value: type.id,
    })) || [];

  const apurements =
    tiReducer?.apurements?.map((type) => ({
      label: " (" + type.code + ") " + type.description,
      value: type.id,
    })) || [];

  const localites =
    tiReducer?.localites?.map((type) => ({
      label: type.description + " (" + type.code + ")",
      value: type.id,
    })) || [];

  const typeTEOptions =
    tiReducer?.typeTE?.map((te) => ({
      label: te.description,
      value: te.id,
    })) || [];

  const typeTIOptions =
    tiReducer?.typeTI?.map((ti) => ({
      label: ti.description,
      value: ti.id,
    })) || [];

  //Guichet Recherche
  const [openGuichetPopup, setOpenGuichetPopup] = useState(false);
  const [codeGuichet, setCodeGuichet] = useState("");
  const [descriptionGuichet, setDescriptionGuichet] = useState("");
  const [adresseGuichet, setAdresseGuichet] = useState("");
  const [nomGuichet, setNomGuichet] = useState("");
  const [selectedBanqueGuichet, setSelectedBanqueGuichet] = useState(null);
  const [selectedLocaliteGuichet, setSelectedLocaliteGuichet] = useState(null);

  const guichetColumns = [
    {
      field: "description",
      headerName: "Raison sociale",
      minWidth: 150,
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "code",
      headerName: "Code",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "adresse",
      headerName: "Adresse",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "banque",
      headerName: "Banque",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "localite",
      headerName: "Localité",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
  ];

  const guichetRows = [];

  tiReducer?.guichets?.content?.map((row, index) => {
    guichetRows.push({
      id: row?.id,
      code: row?.code !== null ? row?.code : "-",
      description: row?.description !== null ? row?.description : "-",
      adresse: row?.direction !== null ? row?.direction : "-",
      banque:
        row?.banque?.description !== null ? row?.banque?.description : "-",
      localite: "",
    });
  });

  const [guichetPagination, setGuichetPagination] = useState({
    page: 0,
    pageSize: 5,
  });

  const [searchGuichetObject, setSearchGuichetObject] = useState({
    code: "",
    adresse: "",
    nom: "",
    idBanque: "",
    localite: "",
    pageNumber: 0,
    pageSize: 5,
  });

  //Nomenclature Recherche
  const [openNomenclaturePopup, setOpenNomenclaturePopup] = useState(false);

  const [codeNomenclature, setCodeNomenclature] = useState("");
  const [descriptionNomenclature, setDescriptionNomenclature] = useState("");
  const [typeTI, setTypeTI] = useState("");
  const [typeTE, setTypeTE] = useState("");
  const nomenclatureColumns = [
    {
      field: "code",
      headerName: "Code",
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "typeTI",
      headerName: "Type TI",
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "typeTE",
      headerName: "Type TE",
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
  ];

  const nomenclatureRows = [];

  tiReducer?.nomenclatures?.content?.map((row, index) => {
    nomenclatureRows.push({
      id: row?.id,
      code: row?.code,
      description: row?.description,
      typeTI: row?.typeTi?.description,
      typeTE: row?.typeTe?.description,
    });
  });

  const [nomenclaturePagination, setNomenclaturePagination] = useState({
    page: 0,
    pageSize: 5,
  });

  const [searchNomenclatureObject, setSearchNomenclatureObject] = useState({
    code: "",
    description: "",
    typeTI: "",
    typeTE: "",
    pageNumber: 0,
    pageSize: 5,
  });

  //Importateur Recherche
  const [openImportateurPopup, setOpenImportateurPopup] = useState(false);
  const [nomImportateur, setNomImportateur] = useState("");
  const [codeImportateur, setCodeImportateur] = useState("");
  const [codePIN, setCodePIN] = useState("");

  const importateurColumns = [
    {
      field: "nom",
      headerName: "Raison sociale",
      minWidth: 150,
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "code",
      headerName: "Code",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "ifu",
      headerName: "IFU",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "ice",
      headerName: "ICE",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "numeroRC",
      headerName: "Numéro RC",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "centreRC",
      headerName: "Centre RC",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
  ];

  const importateurRows = [];

  tiReducer?.importateurs?.content?.map((row, index) => {
    importateurRows.push({
      id: row?.id,
      nom: row?.description,
      code: row?.code,
      ifu: row?.ifu,
      ice: row?.ice,
      numeroRC: row?.numeroRc,
      centreRC: row?.centreRc,
    });
  });

  const [importateurPagination, setImportateurPagination] = useState({
    page: 0,
    pageSize: 5,
  });

  const [searchImportateurObject, setSearchImportateurObject] = useState({
    code: "",
    description: "",
    codePIN: "",
    centreRC: "",
    numeroRC: "",
    ice: "",
    ifu: "",
    pageNumber: 0,
    pageSize: 5,
  });

  const [creationDateDuError, setCreationDateDuError] = useState(null);
  const [creationDateAuError, setCreationDateAuError] = useState(null);

  const [openDeclarantPopup, setOpenDeclarantPopup] = useState(false);
  const [iceError, setIceError] = useState(null);
  const [ifu, setIfu] = useState("");
  const [ice, setIce] = useState("");
  const [numRc, setnumRc] = useState("");
  const [centreRC, setCentreRC] = useState("");

  const [codeDeclarant, setCodeDeclarant] = useState("");
  const [descriptionDeclarant, setDescriptionDeclarant] = useState("");
  const declarantColumns = [
    {
      field: "code",
      headerName: "Code",
      minWidth: 150,
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "nom",
      headerName: "Raison sociale",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "centreRC",
      headerName: "Centre RC",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "numeroRc",
      headerName: "Numéro RC",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "ice",
      headerName: "ICE",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "ifu",
      headerName: "IFU",
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
  ];

  const declarantRows = [];

  tiReducer?.declarants?.content?.map((row, index) => {
    declarantRows.push({
      id: row.id,
      code: row.code,
      nom: row.description,
      ifu: row.ifu,
      ice: row.ice,
      numeroRc: row.numRc,
      centreRC: row.centreRc,
    });
  });

  const [declarantPagination, setDeclarantPagination] = useState({
    page: 0,
    pageSize: 5,
  });

  const [searchDeclarantObject, setSearchDeclarantObject] = useState({
    centreRc: "",
    code: "",
    codePIN: "",
    description: "",
    ice: "",
    ifu: "",
    numeroRc: "",
    pageNumber: 0,
    pageSize: 5,
  });

  const handleRecherche = () => {
    if ((!dateCreationDu || !dateCreationAu) && !numEnr) {
      setExpanded(true);
      if (!dateCreationDu) {
        setCreationDateDuError("Champ obligatoire");
      }
      if (!dateCreationAu) {
        setCreationDateAuError("Champ obligatoire");
      }
      return;
    }
    setCreationDateDuError(null);
    setCreationDateAuError(null);
    const updatedSearchObject = {
      modeConsultation: isModeConsultation,
      tiDto: {
        numEnr: numEnr,
        numDom: numDom,
        idEtat: selectedEtat?.value || "",
        idCategorie: selectedCategorie?.value || "",
        idStatusModif: selectedStatusModif?.value || "",
        idTypeMessage: selectedTypeMessage?.value || "",
        idReglement: selectedReglement?.value || "",
        idApurement: selectedApurement?.value || "",
        idBanque: selectedBanque?.value || "",
        idGuichet: idGuichet || "",
        idDeclarant: idDeclarant || "",
        idNomenclature: idNomenclature || "",
        idImportateur: idImportateur || "",
        nomenclatureNom: nomenclatureNom || "",
        declarantNom: declarantNom || "",
        guichetNom: guichetNom || "",
        importateurNom: importateurNom || "",
        fromDateCreation: dateCreationDu
          ? formattedDateFromDB(dateCreationDu)
          : "",
        toDateCreation: dateCreationAu
          ? formattedDateFromDB(dateCreationAu)
          : "",
        refFact: refFact,
        fromDateDomiciliation: dateDomiciliationDu
          ? formattedDateFromDB(dateDomiciliationDu)
          : "",
        toDateDomiciliation: dateDomiciliationAu
          ? formattedDateFromDB(dateDomiciliationAu)
          : "",
      },
      pagination: {
        page: 0,
        pageSize: pagination?.pageSize,
      },
    };

    setSearchObject(updatedSearchObject);
    const isAccordionExpanded = expanded;

    props.onSearchData(updatedSearchObject, isAccordionExpanded);
  };

  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      handleRecherche();
    }
  };

  const handleEffaceRecherche = () => {
    setResetKey((prevKey) => prevKey + 1);
    setNumEnr("");
    setNumDom("");
    setRefFact("");
    setDateCreationDu(null);
    setDateCreationAu(null);
    setDateDomiciliationDu(null);
    setDateDomiciliationAu(null);
    setSelectedEtat(null);
    setSelectedCategorie(null);
    setSelectedStatusModif(null);
    setSelectedTypeMessage(null);
    setSelectedBanque(null);
    setSelectedReglement(null);
    setSelectedApurement(null);
    setIdNomenclature("");
    setIdGuichet("");
    setIdDeclarant("");
    setIdImportateur("");
    setNomenclatureNom("");
    setGuichetNom("");
    setDeclarantNom("");
    setImportateurNom("");

    const updatedSearchObject = {
      modeConsultation: isModeConsultation,
      tiDto: {
        numEnr: "",
        numDom: "",
        idEtat: "",
        idCategorie: "",
        idStatusModif: "",
        idTypeMessage: "",
        idReglement: "",
        idApurement: "",
        idBanque: "",
        idGuichet: "",
        idDeclarant: "",
        idNomenclature: "",
        idImportateur: "",
        nomenclatureNom: "",
        declarantNom: "",
        guichetNom: "",
        importateurNom: "",
        fromDateCreation: "",
        toDateCreation: "",
        refFact: "",
        fromDateDomiciliation: "",
        toDateDomiciliation: "",
      },
      pagination: {
        page: 0,
        pageSize: props.pagination.pageSize,
      },
    };
    setSearchObject(updatedSearchObject);
    // props.onSearchData(updatedSearchObject);
  };

  //Functions Importateur
  useEffect(() => {
    setSearchImportateurObject((prevState) => ({
      ...prevState,
      pageNumber: importateurPagination.page,
      pageSize: importateurPagination.pageSize,
    }));
  }, [importateurPagination]);

  useEffect(() => {
    if (openImportateurPopup) {
      const payload = searchImportateurObject;
      dispatch(getTiImportateurs(payload));
    }
  }, [dispatch, searchImportateurObject, openImportateurPopup]);

  const onOpenImportateurs = () => {
    setImportateurPagination({ page: 0, pageSize: 5 });
    setSearchImportateurObject({
      code: "",
      description: "",
      codePIN: "",
      centreRC: "",
      numeroRC: "",
      ice: "",
      ifu: "",
      pageNumber: 0,
      pageSize: 5,
    });
    let payload = searchImportateurObject;
    dispatch(getTiImportateurs(payload));
    setOpenImportateurPopup(true);
  };

  const onHandleSelectImportateur = (params) => {
    setImportateurNom(params.row.nom);
    setIdImportateur(params.row.id);
    setOpenImportateurPopup(false);
    onHandleEffacerImportateur();
  };

  const onClearImportateur = () => {
    setImportateurNom("");
    setIdImportateur("");
  };

  const onHandleCloseImportateur = () => {
    setOpenImportateurPopup(false);
    setCodeImportateur("");
    setNomImportateur("");
    setCentreRC("");
    setCodePIN("");
    setIce("");
    setIfu("");
    setnumRc("");
  };

  const onHandleSearchImportateur = () => {
    setImportateurPagination({
      page: 0,
      pageSize: searchImportateurObject.pageSize,
    });

    setSearchImportateurObject({
      ...searchImportateurObject,
      code: codeImportateur || "",
      description: nomImportateur || "",
      codePIN: codePIN || "",
      centreRC: centreRC || "",
      numeroRC: numRc || "",
      ice: ice || "",
      ifu: ifu || "",
      pageNumber: 0,
      pageSize: 5,
    });
  };

  const onHandleEffacerImportateur = () => {
    setImportateurPagination({
      page: 0,
      pageSize: importateurPagination.pageSize,
    });

    setCodeImportateur("");
    setNomImportateur("");
    setCentreRC("");
    setCodePIN("");
    setIce("");
    setIfu("");
    setnumRc("");
    setSearchImportateurObject((prevState) => ({
      ...prevState,
      code: "",
      description: "",
      codePIN: "",
      centreRC: "",
      numeroRC: "",
      ice: "",
      ifu: "",
      pageNumber: 0,
      pageSize: 5,
    }));
  };

  const handleImportateurEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      onHandleSearchImportateur();
    }
  };

  //Functions nomenclature
  useEffect(() => {
    setSearchNomenclatureObject((prevState) => ({
      ...prevState,
      pageNumber: nomenclaturePagination.page,
      pageSize: nomenclaturePagination.pageSize,
    }));
  }, [nomenclaturePagination]);

  useEffect(() => {
    if (openNomenclaturePopup) {
      const payload = searchNomenclatureObject;
      dispatch(getTiNomenclatures(payload));
    }
  }, [dispatch, searchNomenclatureObject, openNomenclaturePopup]);

  const onOpenNomenclatures = () => {
    dispatch(getTiTypeTE());
    dispatch(getTiTypeTI());
    setNomenclaturePagination({ page: 0, pageSize: 5 });
    setSearchNomenclatureObject({
      code: "",
      description: "",
      typeTI: "",
      typeTE: "",
      pageNumber: 0,
      pageSize: 5,
    });
    let payload = searchNomenclatureObject;
    dispatch(getTiNomenclatures(payload));
    setOpenNomenclaturePopup(true);
  };

  const onHandleSelectNomenclature = (params) => {
    setIdNomenclature(params.row.id);
    setNomenclatureNom(params.row.code + " - " + params.row.description);
    setOpenNomenclaturePopup(false);
    onHandleEffacerNomenclature();
  };

  const onClearNomenclature = () => {
    setIdNomenclature("");
    setNomenclatureNom("");
  };

  const onHandleCloseNomenclature = () => {
    setOpenNomenclaturePopup(false);
    setCodeNomenclature("");
    setDescriptionNomenclature("");
    setTypeTE("");
    setTypeTI("");
  };

  const onHandleSearchNomenclature = () => {
    setNomenclaturePagination({
      page: 0,
      pageSize: searchNomenclatureObject.pageSize,
    });

    setSearchNomenclatureObject({
      ...searchNomenclatureObject,
      code: codeNomenclature || "",
      description: descriptionNomenclature || "",
      typeTE: typeTE,
      typeTI: typeTI,
      pageNumber: 0,
      pageSize: searchNomenclatureObject.pageSize,
    });
  };

  const onHandleEffacerNomenclature = () => {
    setNomenclaturePagination({
      page: 0,
      pageSize: nomenclaturePagination.pageSize,
    });

    setCodeNomenclature("");
    setDescriptionNomenclature("");
    setTypeTI("");
    setTypeTE("");
    setSearchNomenclatureObject((prevState) => ({
      ...prevState,
      code: "",
      description: "",
      typeTE: "",
      typeTI: "",
      pageNumber: 0,
      pageSize: prevState.pageSize,
    }));
  };

  const handleNomenclatureEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      onHandleSearchNomenclature();
    }
  };

  //Functions Guichet
  useEffect(() => {
    setSearchGuichetObject((prevState) => ({
      ...prevState,
      pageNumber: guichetPagination.page,
      pageSize: guichetPagination.pageSize,
    }));
  }, [guichetPagination]);

  useEffect(() => {
    if (openGuichetPopup) {
      const payload = searchGuichetObject;
      dispatch(getTiGuichets(payload));
    }
  }, [dispatch, searchGuichetObject, openGuichetPopup]);

  const onOpenGuichets = () => {
    setGuichetPagination({ page: 0, pageSize: 5 });
    setSearchGuichetObject({
      code: "",
      adresse: "",
      nom: "",
      idBanque: "",
      localite: "",
      pageNumber: 0,
      pageSize: 5,
    });
    let payload = searchGuichetObject;
    dispatch(getTiGuichets(payload));
    setOpenGuichetPopup(true);
  };

  const onHandleSelectGuichet = (params) => {
    setIdGuichet(params.row.id);

    if (params.row.description?.trim().length > 0) {
      setGuichetNom(params.row.description);
    } else {
      setGuichetNom("-");
    }
    setOpenGuichetPopup(false);
    onHandleEffacerGuichet();
  };

  const onClearGuichet = () => {
    setIdGuichet("");
    setGuichetNom("");
  };

  const onHandleSearchGuichet = () => {
    setGuichetPagination({
      page: 0,
      pageSize: searchGuichetObject.pageSize,
    });

    setSearchGuichetObject({
      ...searchGuichetObject,
      code: codeGuichet || "",
      adresse: adresseGuichet || "",
      nom: descriptionGuichet || "",
      idBanque: selectedBanqueGuichet?.value || "",
      pageNumber: 0,
      pageSize: searchGuichetObject.pageSize,
    });
  };

  const onHandleEffacerGuichet = () => {
    setGuichetPagination({
      page: 0,
      pageSize: guichetPagination.pageSize,
    });

    setCodeGuichet("");
    setAdresseGuichet("");
    setNomGuichet("");
    setDescriptionGuichet("");
    setSelectedBanqueGuichet(null);
    setSelectedLocaliteGuichet(null);
    setSearchGuichetObject((prevState) => ({
      ...prevState,
      code: "",
      adresse: "",
      nom: "",
      idBanque: "",
      pageNumber: 0,
      pageSize: prevState.pageSize,
    }));
  };

  const onHandleCloseGuichet = () => {
    setOpenGuichetPopup(false);
    setCodeGuichet("");
    setAdresseGuichet("");
    setDescriptionGuichet("");
    setSelectedBanqueGuichet("");
    setSelectedLocaliteGuichet("");
  };

  const handleGuichetEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      onHandleSearchGuichet();
    }
  };

  //Functions déclarant
  useEffect(() => {
    setSearchDeclarantObject((prevState) => ({
      ...prevState,
      pageNumber: declarantPagination.page,
      pageSize: declarantPagination.pageSize,
    }));
  }, [declarantPagination]);

  useEffect(() => {
    if (openDeclarantPopup) {
      const payload = searchDeclarantObject;
      dispatch(getTiDeclarants(payload));
    }
  }, [dispatch, searchDeclarantObject, openDeclarantPopup]);

  const onOpenDeclarants = () => {
    setDeclarantPagination({ page: 0, pageSize: 5 });
    setSearchDeclarantObject({
      centreRc: "",
      code: "",
      description: "",
      ice: "",
      ifu: "",
      numeroRc: "",
      pageNumber: 0,
      pageSize: 5,
    });
    let payload = searchDeclarantObject;
    dispatch(getTiDeclarants(payload));
    setOpenDeclarantPopup(true);
  };

  const onHandleSelectDeclarant = (params) => {
    setIdDeclarant(params.row.id);
    setDeclarantNom(params.row.nom);
    setOpenDeclarantPopup(false);
    onHandleEffacerDeclarants();
  };

  const onClearDeclarant = () => {
    setDeclarantNom("");
    setIdDeclarant("");
  };

  const onHandleSearchDeclarant = () => {
    const isIceValid = iceRegex.test(ice);
    if (isIceValid || ice === "") {
      setIceError(null);
      setSearchDeclarantObject({
        page: 0,
        pageSize: searchDeclarantObject.pageSize,
      });
      setSearchDeclarantObject({
        ...searchDeclarantObject,
        centreRc: centreRC || "",
        code: codeDeclarant || "",
        description: descriptionDeclarant || "",
        ice: ice || "",
        ifu: ifu || "",
        numeroRc: numRc || "",
        pageNumber: 0,
        pageSize: searchDeclarantObject.pageSize,
      });
    } else {
      setIceError("ICE doit être une chaine numérique de 15 nombre");
    }
  };

  const onHandleEffacerDeclarants = () => {
    setDeclarantPagination({
      page: 0,
      pageSize: declarantPagination.pageSize,
    });
    setIceError(null);
    setCodeDeclarant("");
    setDescriptionDeclarant("");
    setCentreRC("");
    setIce("");
    setIfu("");
    setnumRc("");
    setSearchDeclarantObject((prevState) => ({
      ...prevState,
      centreRc: "",
      code: "",
      description: "",
      ice: "",
      ifu: "",
      numeroRc: "",
      pageNumber: 0,
      pageSize: prevState.pageSize,
    }));
  };

  const onHandleCloseDeclarant = () => {
    setOpenDeclarantPopup(false);
    setCodeDeclarant("");
    setDescriptionDeclarant("");
    setCentreRC("");
    setIce("");
    setIfu("");
    setnumRc("");
  };

  const handleDeclarantEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      onHandleSearchDeclarant();
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", paddingRight: 1 }}>
      <Box sx={{ mb: 2 }}>
        <Link
          onClick={() => setExpanded(!expanded)}
          underline="none"
          sx={{
            float: "right",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: 600,
            mr: 2,
            border: "none",
          }}
        >
          Recherche avancée
        </Link>
      </Box>
      <Accordion
        expanded={expanded}
        sx={{ background: "transparent", boxShadow: "none" }}
      >
        <Grid container spacing={1}>
          <Grid item md={3} xs={12}>
            <TextFieldCustomized
              label="N° d'enregistrement"
              placeholder="2020300000000000800"
              onChange={setNumEnr}
              value={numEnr}
              onKeyPress={handleEnterKeyPress}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <AutocompleteCustomized
              key={resetKey}
              label="Catégorie du titre"
              placeholder="(LI) Licence d'importation"
              options={categories}
              onChange={(value) => setSelectedCategorie(value)}
              value={selectedCategorie}
              onKeyPress={handleEnterKeyPress}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <AutocompleteCustomized
              key={resetKey}
              label="État"
              placeholder="(ALT) Nouveau"
              options={etats}
              onChange={(value) => setSelectedEtat(value)}
              value={selectedEtat}
              onKeyPress={handleEnterKeyPress}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <AutocompleteCustomized
              key={resetKey}
              label="Status de modification"
              placeholder="Modifié"
              options={statusModif}
              onChange={(value) => setSelectedStatusModif(value)}
              value={selectedStatusModif}
              onKeyPress={handleEnterKeyPress}
            />
          </Grid>
        </Grid>
        <AccordionDetails
          style={{ paddingRight: 0, paddingLeft: 0, marginBottom: "-30px" }}
        >
          <Grid container spacing={1}>
            <Grid item md={3} xs={12}>
              <AutocompleteCustomized
                key={resetKey}
                label="Type de message"
                placeholder="(D) Soumis"
                options={typeMessages}
                onChange={(value) => setSelectedTypeMessage(value)}
                value={selectedTypeMessage}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <TextFieldCustomized
                label="Guichet"
                placeholder="Guichet 1"
                icon={<SearchIcon />}
                onIconClick={onOpenGuichets}
                onClearClick={onClearGuichet}
                value={guichetNom}
                valeur={guichetNom}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <TextFieldCustomized
                label="Importateur"
                placeholder="Importateur"
                icon={<SearchIcon />}
                onIconClick={onOpenImportateurs}
                onClearClick={onClearImportateur}
                value={importateurNom}
                valeur={importateurNom}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <TextFieldCustomized
                label="Déclarant"
                placeholder="PLASTI FOOD"
                icon={<SearchIcon />}
                onIconClick={onOpenDeclarants}
                onClearClick={onClearDeclarant}
                value={declarantNom}
                valeur={declarantNom}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <TextFieldCustomized
                label="Nomenclature douanière"
                placeholder="0101299000-autres"
                icon={<SearchIcon />}
                onIconClick={onOpenNomenclatures}
                onClearClick={onClearNomenclature}
                value={nomenclatureNom}
                valeur={nomenclatureNom}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <DatePickerCustomized
                label="Date de début de création"
                value={dateCreationDu}
                onChange={(v) => {
                  setDateCreationDu(v);
                  setCreationDateDuError(null);
                }}
                onKeyPress={handleEnterKeyPress}
                maxDate={new Date()}
                obligatoire={true}
                error={creationDateDuError}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <DatePickerCustomized
                label="Au"
                value={dateCreationAu}
                onChange={(v) => {
                  setDateCreationAu(v);
                  setCreationDateAuError(null);
                }}
                onKeyPress={handleEnterKeyPress}
                obligatoire={true}
                error={creationDateAuError}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextFieldCustomized
                label="Référence facture"
                placeholder="39873983202"
                onChange={setRefFact}
                value={refFact}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <TextFieldCustomized
                label="N° de domiciliation"
                placeholder="2020300000000000800"
                onChange={setNumDom}
                value={numDom}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <DatePickerCustomized
                label="Date de domiciliation du"
                value={dateDomiciliationDu}
                onChange={setDateDomiciliationDu}
                onKeyPress={handleEnterKeyPress}
                maxDate={new Date()}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <DatePickerCustomized
                label="Au"
                value={dateDomiciliationAu}
                onChange={setDateDomiciliationAu}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <AutocompleteCustomized
                key={resetKey}
                label="Type du règlement"
                placeholder="Règlement Total"
                options={reglements}
                onChange={(value) => setSelectedReglement(value)}
                value={selectedReglement}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <AutocompleteCustomized
                key={resetKey}
                label="Situation d'apurement"
                placeholder="Apuré"
                options={apurements}
                onChange={(value) => setSelectedApurement(value)}
                value={selectedApurement}
                onKeyPress={handleEnterKeyPress}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Box
        sx={{
          pt: "20px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <ButtonCustomized
          variant="outlined"
          startIcon={<RefreshIcon />}
          title="Réinitialiser"
          onClick={() => handleEffaceRecherche()}
        />
        <ButtonCustomized
          variant="contained"
          endIcon={<SearchIcon />}
          title="Rechercher"
          onClick={handleRecherche}
        />
      </Box>

      <Dialog
        open={openGuichetPopup}
        onClose={onHandleCloseGuichet}
        sx={{ "& .MuiDialog-paper": { maxWidth: "65vw", minWidth: "65vw" } }}
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onHandleCloseGuichet}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" color="primary">
            Guichet
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: "20px",
              marginTop: 2,
            }}
          >
            <PaperCustomized title="Paramètres de recherche">
              <Box sx={{ display: "flex", gap: "20px", paddingRight: 0.5 }}>
                <Grid container spacing={1} sx={{ marginHorizontal: "0px" }}>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Code"
                      width={200}
                      onChange={setCodeGuichet}
                      value={codeGuichet}
                      onKeyPress={handleGuichetEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Adresse"
                      width={200}
                      onChange={setAdresseGuichet}
                      value={adresseGuichet}
                      onKeyPress={handleGuichetEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Raison sociale"
                      width={300}
                      onChange={setDescriptionGuichet}
                      value={descriptionGuichet}
                      onKeyPress={handleGuichetEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <AutocompleteCustomized
                      key={resetKey}
                      label="Banque"
                      placeholder="Banque1"
                      options={banquesGuichet}
                      onChange={(value) => setSelectedBanqueGuichet(value)}
                      value={selectedBanqueGuichet}
                      onKeyPress={handleEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <AutocompleteCustomized
                      key={resetKey}
                      label="Localité"
                      placeholder="VILLE (N'9999')"
                      options={localites}
                      onChange={(value) => setSelectedLocaliteGuichet(value)}
                      value={selectedLocaliteGuichet}
                      onKeyPress={handleEnterKeyPress}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  pt: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  mr: 1,
                }}
              >
                <ButtonCustomized
                  variant="outlined"
                  startIcon={<RefreshIcon />}
                  title="Réinitialiser"
                  onClick={onHandleEffacerGuichet}
                />
                <ButtonCustomized
                  variant="contained"
                  endIcon={<SearchIcon />}
                  title="Rechercher"
                  onClick={onHandleSearchGuichet}
                />
              </Box>
            </PaperCustomized>
            <PaperCustomized title="Liste des Guichets">
              <TableCustomized
                columns={guichetColumns}
                rows={guichetRows}
                totalElements={tiReducer?.guichets?.totalElements}
                pageSizeOptions={[5, 40, 50, 100]}
                onClickRow={(params) => onHandleSelectGuichet(params)}
                paginationModel={guichetPagination}
                setPaginationModel={setGuichetPagination}
                pagination={guichetPagination}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                  },
                }}
                loading={isLoading}
                isSlots={false}
              />
            </PaperCustomized>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openNomenclaturePopup}
        onClose={onHandleCloseNomenclature}
        sx={{ "& .MuiDialog-paper": { maxWidth: "65vw", minWidth: "65vw" } }}
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onHandleCloseNomenclature}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" color="primary">
            Nomenclatures douanières
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: "20px",
              marginTop: 2,
            }}
          >
            <PaperCustomized title="Paramètres de recherche">
              <Box sx={{ display: "flex", gap: "20px", paddingRight: 0.5 }}>
                <Grid container spacing={1} sx={{ marginLeft: "0px" }}>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Code"
                      onChange={setCodeNomenclature}
                      value={codeNomenclature}
                      onKeyPress={handleNomenclatureEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Description"
                      onChange={setDescriptionNomenclature}
                      value={descriptionNomenclature}
                      onKeyPress={handleNomenclatureEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <SelectCustomized
                      label="Type TI"
                      allowTyping={false}
                      options={typeTIOptions}
                      onChange={setTypeTI}
                      value={typeTI}
                      onKeyPress={handleNomenclatureEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <SelectCustomized
                      label="Type TE"
                      allowTyping={false}
                      options={typeTEOptions}
                      onChange={setTypeTE}
                      value={typeTE}
                      onKeyPress={handleNomenclatureEnterKeyPress}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  pt: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  mr: 1,
                }}
              >
                <ButtonCustomized
                  variant="outlined"
                  startIcon={<RefreshIcon />}
                  title="Réinitialiser"
                  onClick={onHandleEffacerNomenclature}
                />
                <ButtonCustomized
                  variant="contained"
                  endIcon={<SearchIcon />}
                  title="Rechercher"
                  onClick={onHandleSearchNomenclature}
                />
              </Box>
            </PaperCustomized>
            <PaperCustomized title="Liste des nomenclatures">
              <TableCustomized
                columns={nomenclatureColumns}
                rows={nomenclatureRows}
                totalElements={tiReducer?.nomenclatures?.totalElements}
                pageSizeOptions={[5, 40, 50, 100]}
                onClickRow={(params) => onHandleSelectNomenclature(params)}
                paginationModel={nomenclaturePagination}
                setPaginationModel={setNomenclaturePagination}
                pagination={nomenclaturePagination}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                  },
                }}
                loading={isLoading}
                isSlots={false}
              />
            </PaperCustomized>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openDeclarantPopup}
        onClose={onHandleCloseDeclarant}
        sx={{ "& .MuiDialog-paper": { maxWidth: "80vw", minWidth: "80vw" } }}
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onHandleCloseDeclarant}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" color="primary">
            Transitaires
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: "20px",
              marginTop: 2,
            }}
          >
            <PaperCustomized title="Paramètres de recherche">
              <Box sx={{ display: "flex", gap: "20px", paddingRight: 0.5 }}>
                <Grid container spacing={1} sx={{ marginHorizontal: "0px" }}>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Code"
                      width={200}
                      onChange={setCodeDeclarant}
                      value={codeDeclarant}
                      onKeyPress={handleDeclarantEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Raison sociale"
                      width={200}
                      onChange={setDescriptionDeclarant}
                      value={descriptionDeclarant}
                      onKeyPress={handleDeclarantEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="IFU"
                      width={200}
                      onChange={setIfu}
                      value={ifu}
                      onKeyPress={handleDeclarantEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="ICE"
                      width={200}
                      onChange={setIce}
                      value={ice}
                      onKeyPress={handleDeclarantEnterKeyPress}
                      error={iceError}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Numéro RC"
                      width={200}
                      onChange={setnumRc}
                      value={numRc}
                      onKeyPress={handleDeclarantEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Centre RC"
                      width={200}
                      onChange={setCentreRC}
                      value={centreRC}
                      onKeyPress={handleDeclarantEnterKeyPress}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  pt: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  mr: 1,
                }}
              >
                <ButtonCustomized
                  variant="outlined"
                  startIcon={<RefreshIcon />}
                  title="Réinitialiser"
                  onClick={onHandleEffacerDeclarants}
                />
                <ButtonCustomized
                  variant="contained"
                  endIcon={<SearchIcon />}
                  title="Rechercher"
                  onClick={onHandleSearchDeclarant}
                />
              </Box>
            </PaperCustomized>
            <PaperCustomized title="Liste des transitaires">
              <TableCustomized
                columns={declarantColumns}
                rows={declarantRows}
                totalElements={tiReducer?.declarants?.totalElements}
                pageSizeOptions={[5, 40, 50, 100]}
                onClickRow={(params) => onHandleSelectDeclarant(params)}
                paginationModel={declarantPagination}
                setPaginationModel={setDeclarantPagination}
                pagination={declarantPagination}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                  },
                }}
                loading={isLoading}
                isSlots={false}
              />
            </PaperCustomized>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openImportateurPopup}
        onClose={onHandleCloseImportateur}
        sx={{ "& .MuiDialog-paper": { maxWidth: "80vw", minWidth: "80vw" } }}
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onHandleCloseImportateur}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" color="primary">
            Importateur
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: "20px",
              marginTop: 2,
            }}
          >
            <PaperCustomized title="Paramètres de recherche">
              <Box sx={{ display: "flex", gap: "20px", paddingRight: 0.5 }}>
                <Grid container spacing={1} sx={{ marginHorizontal: "0px" }}>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Code"
                      width={200}
                      onChange={setCodeImportateur}
                      value={codeImportateur}
                      onKeyPress={handleImportateurEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Raison sociale"
                      width={200}
                      onChange={setNomImportateur}
                      value={nomImportateur}
                      onKeyPress={handleImportateurEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Code PIN"
                      width={200}
                      onChange={setCodePIN}
                      value={codePIN}
                      onKeyPress={handleImportateurEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Centre RC"
                      width={200}
                      onChange={setCentreRC}
                      value={centreRC}
                      onKeyPress={handleImportateurEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="Numéro RC"
                      width={200}
                      onChange={setnumRc}
                      value={numRc}
                      onKeyPress={handleImportateurEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="ICE"
                      width={200}
                      onChange={setIce}
                      value={ice}
                      onKeyPress={handleImportateurEnterKeyPress}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextFieldCustomized
                      label="IFU"
                      width={200}
                      onChange={setIfu}
                      value={ifu}
                      onKeyPress={handleImportateurEnterKeyPress}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  pt: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  mr: 1,
                }}
              >
                <ButtonCustomized
                  variant="outlined"
                  startIcon={<RefreshIcon />}
                  title="Réinitialiser"
                  onClick={onHandleEffacerImportateur}
                />
                <ButtonCustomized
                  variant="contained"
                  endIcon={<SearchIcon />}
                  title="Rechercher"
                  onClick={onHandleSearchImportateur}
                />
              </Box>
            </PaperCustomized>
            <PaperCustomized title="Liste des importateurs">
              <TableCustomized
                columns={importateurColumns}
                rows={importateurRows}
                totalElements={tiReducer?.importateurs?.totalElements}
                pageSizeOptions={[5, 40, 50, 100]}
                onClickRow={(params) => onHandleSelectImportateur(params)}
                paginationModel={importateurPagination}
                setPaginationModel={setImportateurPagination}
                pagination={importateurPagination}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                  },
                }}
                loading={isLoading}
                isSlots={false}
              />
            </PaperCustomized>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default SearchTitreForm;
